import type { LogbookSettingsState } from "@dexteel/mesf-core";

// Module scope on purpose: LogbookSettingsContext memoizes on this object's identity
export const logbookSettings: Partial<LogbookSettingsState> = {
	entry: {
		withAssetFilter: "tree",
		canEditAsset: true,
		allowAttachments: true,
		canEditShift: true,
		showShiftCrew: true,
		exportToExcel: true,
		shiftsRange: 7,
	},
	report: {
		withAssetFilter: "tree",
		showAttachments: true,
		showAsset: true,
		showShiftCrew: true,
		exportToExcel: true,
	},
};
